module.exports = __webpack_public_path__ + "img/MAMO-VIOLA-DBT-monocolumna.7054805c.png";